if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        document.dispatchEvent(new Event("loading:start"));

        if (this.submitButton.getAttribute("aria-disabled") === "true") {
          return;
        }
        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.toggleAttribute("disabled", true);
        this.submitButton.querySelector("span").textContent =
          window.variantStrings.adding;
        this.submitButton.classList.add("!cursor-wait");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
            }

            const cartUpdateEvent = new CustomEvent("cart:update", {
              detail: {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              },
            });

            window.dispatchEvent(cartUpdateEvent);
            this.error = false;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("!cursor-wait");
            this.submitButton.querySelector("span").textContent =
              window.variantStrings.addToCart;
            this.submitButton.toggleAttribute("disabled", false);

            document.dispatchEvent(new Event("loading:end"));

            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector("[data-product-form-error-message-wrapper]");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            "[data-product-form-error-message]"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(
        disable = true,
        text,
        backgroundClassName,
        textClassName
      ) {
        if (disable) {
          if (backgroundClassName === "bg-gray-200") {
            this.submitButton.classList.add(backgroundClassName);
            this.submitButton.classList.add(textClassName);
            this.submitButton.classList.remove("bg-black");
            this.submitButton.classList.remove("text-white");
          }
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          if (backgroundClassName) {
            this.submitButton.classList.remove(backgroundClassName);
            this.submitButton.classList.remove(textClassName);
          }

          this.submitButton.classList.add("bg-black");
          this.submitButton.classList.add("text-white");

          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}

function stickyAddToCart() {
  const addToCartButton = document.querySelector("product-form button");
  const addToCartButtonWrapper = document.querySelector(
    "product-form [data-atc-button-wrapper]"
  );

  if (!addToCartButton || !addToCartButtonWrapper) return;

  const footerLogo = document.querySelector(".footer__logo");
  const stickyClassesArray = [
    "fixed",
    "lg:static",
    "top-[auto]",
    "lg:top-auto",
    "bottom-3",
    "lg:bottom-auto",
    "inset-x-3",
    "lg:inset-x-auto",
  ];
  const wrapperRect = addToCartButtonWrapper.getBoundingClientRect();
  const footerRect = footerLogo.getBoundingClientRect();
  const threshold = window.innerHeight - 12;
  const footerVisible =
    footerRect.top <= window.innerHeight && footerRect.bottom >= 0;
  if (footerVisible) {
    addToCartButton.classList.remove(...stickyClassesArray);
    addToCartButton.classList.add("w-full");
    return;
  }
  if (wrapperRect.bottom >= threshold || wrapperRect.top <= 0) {
    addToCartButton.classList.add(...stickyClassesArray);
    addToCartButton.classList.remove("w-full");
  } else {
    addToCartButton.classList.remove(...stickyClassesArray);
    addToCartButton.classList.add("w-full");
  }
}
window.addEventListener("scroll", stickyAddToCart);
